import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { StatusPill } from "../../components/Pills";
import { ChevronRight } from "lucide-react";

export default function OperatorFleet() {
  const [stations, setStations] = useState([]);
  const [sel, setSel] = useState(null);
  const [overview, setOverview] = useState(null);

  useEffect(() => {
    const tick = async () => {
      const [{ data: s }, { data: o }] = await Promise.all([
        api.get("/stations"),
        api.get("/analytics/overview"),
      ]);
      setStations(s);
      setOverview(o);
      if (!sel && s[0]) setSel(s[0]);
    };
    tick();
    const t = setInterval(tick, 5000);
    return () => clearInterval(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="p-6 lg:p-8">
      <div className="mb-6">
        <div className="bin-label">OPS</div>
        <h1 className="text-3xl font-black tracking-tighter mt-1">Station Fleet</h1>
      </div>

      {overview && (
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 mb-6">
          <KPI label="Online" value={`${overview.stations_online}/${overview.stations_total}`} color="#4ADE80" />
          <KPI label="Capacity" value={`${overview.total_capacity_kw} kW`} color="#00E5FF" />
          <KPI label="Network Battery" value={`${overview.battery_state_pct}%`} color="#FFA800" />
          <KPI label="Active Sessions" value={overview.active_sessions} color="#FACC15" />
        </div>
      )}

      <div className="grid lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bin-card overflow-hidden">
          <table className="w-full text-xs font-mono">
            <thead className="bg-[#18181b]">
              <tr className="text-left text-zinc-500">
                <th className="px-4 py-3">Station</th>
                <th>Status</th>
                <th>Battery</th>
                <th>Active</th>
                <th className="text-right">kWh Dispensed</th>
                <th className="text-right">Revenue</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {stations.map((s) => (
                <tr
                  key={s.id}
                  data-testid={`fleet-row-${s.id}`}
                  onClick={() => setSel(s)}
                  className={`border-t border-zinc-800 cursor-pointer hover:bg-white/2 ${sel?.id === s.id ? "bg-cyan-500/5" : ""}`}
                >
                  <td className="px-4 py-3">
                    <div className="font-bold text-white">{s.name}</div>
                    <div className="text-zinc-500">{s.address}</div>
                  </td>
                  <td><StatusPill status={s.status} /></td>
                  <td>{Math.round((s.battery_kwh / s.battery_max_kwh) * 100)}%</td>
                  <td>{s.active_sessions}</td>
                  <td className="text-right">{s.total_kwh_dispensed.toFixed(0)}</td>
                  <td className="text-right text-cyan-400 px-4">${s.revenue_usd.toFixed(0)}</td>
                  <td><ChevronRight className="w-4 h-4 text-zinc-600" /></td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {sel && (
          <div className="bin-card p-6 h-fit">
            <div className="bin-label">DRILL-DOWN</div>
            <h2 className="text-xl font-bold mt-1 mb-4">{sel.name}</h2>
            <Row label="Status" value={<StatusPill status={sel.status} />} />
            <Row label="Safety" value={<StatusPill status={sel.safety_state} />} />
            <Row label="Source" value={sel.power_source.toUpperCase()} />
            <Row label="Capacity" value={`${sel.capacity_kw} kW`} />
            <Row label="Battery" value={`${sel.battery_kwh.toFixed(1)} / ${sel.battery_max_kwh} kWh`} />
            <Row label="Uptime" value={`${sel.uptime_pct}%`} />
            <Row label="Active Sessions" value={sel.active_sessions} />
            <Row label="Total kWh" value={sel.total_kwh_dispensed.toFixed(0)} />
            <Row label="Revenue" value={`$${sel.revenue_usd.toFixed(2)}`} />
          </div>
        )}
      </div>
    </div>
  );
}

function KPI({ label, value, color }) {
  return (
    <div className="bin-card p-4">
      <div className="bin-label">{label}</div>
      <div className="text-2xl font-black font-mono mt-1" style={{ color }}>{value}</div>
    </div>
  );
}
function Row({ label, value }) {
  return (
    <div className="flex items-center justify-between py-2 border-b border-zinc-900 text-xs font-mono">
      <span className="text-zinc-500 uppercase tracking-wider">{label}</span>
      <span className="text-white">{value}</span>
    </div>
  );
}
